
import React from 'react';
import LanguagesSection from './LanguagesSection';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { EDUCATION_LEVELS } from '@/data/constants';

interface EducationLanguagesCardProps {
  educationValue: string;
  experienceLevel: string;
  languagesValue: string[];
  setLanguagesValue: (languages: string[]) => void;
  setEducationValue: (value: string) => void;
  setExperienceLevel: (value: string) => void;
}

const EducationLanguagesCard: React.FC<EducationLanguagesCardProps> = ({
  educationValue,
  languagesValue,
  setLanguagesValue,
  setEducationValue,
}) => {
  return (
    <div className="space-y-6">
      {/* Education Section */}
      <div className="space-y-2">
        <label className="text-sm font-medium block">
          Education
        </label>
        <Select value={educationValue} onValueChange={setEducationValue}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select Education" />
          </SelectTrigger>
          <SelectContent>
            {EDUCATION_LEVELS.map((education) => (
              <SelectItem key={education.id} value={education.id} className="data-[highlighted]:bg-gray-200 data-[highlighted]:text-gray-900 px-2 py-3 rounded">
                {education.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Languages Section */}
      <div className="space-y-2">
        <label className="text-sm font-medium block">
          Languages
        </label>
        <div>
          <LanguagesSection
            languagesValue={languagesValue}
            setLanguagesValue={setLanguagesValue}
          />
        </div>
      </div>
    </div>
  );
};

export default EducationLanguagesCard;
